export const MainLayout = ({ debug, children }: any) => {
  return (
    <div className="flex flex-col w-screen aspect-video overflow-y-hidden">
      {children}
    </div>
  );
};
